<template>
  <div
    ref="previewWindow"
    :x-placement="xPlacement"
    class="ivu-poptip-popper preview-popper"
    :class="{'fade-in': showContentPreview }"
    :style="`top: ${previewTop}px; ${horizontalStyling}`"
    @mouseover="onShowHidePreview(true)"
    @mouseleave="onShowHidePreview(false)"
  >
    <div class="ivu-poptip-content">
      <div
        ref="arrow"
        class="ivu-poptip-arrow"
      />
      <div class="ivu-poptip-inner">
        <div class="ivu-poptip-title">
          <div class="title-section">
            <div class="title-block">
              <strong>
                <Icon
                  v-if="isQuery"
                  type="ios-code-working"
                  size="22"
                />
                <i
                  v-else
                  class="fas fa-genderless"
                />
                {{ previewTitle || title }}
              </strong>
            </div>
          </div>
        </div>
        <div class="ivu-poptip-body">
          <div
            v-show="isQuery"
            class="ivu-poptip-body-content"
          >
            <codemirror
              ref="codePreview"
              :value="previewContent.queryText"
              :options="editorPreviewOptions"
              class="query-editor preview"
            />
          </div>
          <div
            v-show="!isQuery"
            ref="previewContent"
            class="ivu-poptip-body-content"
          >
            <p>
              <b>Data Type:</b> {{ previewContent.dataType }}
            </p>
            <p>
              <b>Description:</b>
            </p>
            <p class="description">
              {{ previewContent.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    title: String,
    isQuery: Boolean,
    content: Object,
    width: Number,
    height: Number,
    horizontalPosition: String,
    horizontalOffset: Number,
    referredTopPosition: Number
  },

  data () {
    return {
      xPlacement: '',
      horizontalStyling: '',
      previewTop: 0,
      showContentPreview: false,
      hidePreviewTimeout: 0,
      editorPreviewOptions: {
        theme: 'default',
        tabSize: 4,
        indentUnit: 4,
        smartIndent: true,
        matchBrackets: true,
        closeBrackets: true,
        mode: { name: 'text/x-sql', globalVars: true },
        lineNumbers: true,
        autoRefresh: true,
        readOnly: 'nocursor'
      },
      forceHide: true,
      previewTitle: '',
      previewContent: {
        queryText: '',
        dataType: '',
        description: ''
      }
    }
  },

  watch: {
    referredTopPosition () {
      this.onShowHidePreview(true)
    },
    show (show) {
      this.forceHide = false
      this.onShowHidePreview(show)
    },
    title (newTitle, oldTitle) {
      this.previewTitle = newTitle && newTitle.length > 0 ? newTitle : oldTitle
    },
    content (newContent, oldContent) {
      if (this.isQuery) {
        this.previewContent.queryText = newContent.queryText.length > 0
          ? newContent.queryText : oldContent.queryText
      } else {
        this.previewContent.dataType = newContent.dataType
          ? newContent.dataType : oldContent.dataType
        this.previewContent.description = newContent.description
          ? newContent.description : oldContent.description
      }
    }
  },

  methods: {
    /**
     * Sets the query preview properties on show/hide.
     * @param {Boolean} showPreview
     */
    onShowHidePreview (showPreview) {
      if (this.forceHide) {
        this.$refs.previewWindow.style.display = 'none'
        this.$refs.previewWindow.style.width = '0'
        return
      }

      this.$refs.previewWindow.style.display = 'block'
      this.$refs.previewWindow.style.width = `${this.width}px`
      this.showContentPreview = showPreview

      if (this.isQuery) {
        this.$refs.codePreview.codemirror.setSize(null, this.height)
      } else {
        this.$refs.previewContent.style.height = `${this.height}px`
      }

      if (showPreview) {
        clearTimeout(this.hidePreviewTimeout)
        this.xPlacement = this.horizontalPosition
        this.previewTop = this.referredTopPosition
        this.horizontalStyling = (this.xPlacement.includes('left') ? 'right: ' : 'left: ') + `${this.horizontalOffset}px`
        return
      }

      this.showContentPreview = false
      this.hidePreviewTimeout = setTimeout(() => {
        this.$refs.previewWindow.style.display = 'none'
      }, 300)
    }
  }
}
</script>

<style scoped>
  .preview-popper {
    position: absolute;
    will-change: top;
    opacity: 0;
    transition: opacity 300ms linear;
  }

  .preview-popper.fade-in {
    opacity: 1;
  }

  .preview-popper .ivu-poptip-body {
    min-width: 320px;
  }

  .title-section {
    display: table;
    width: 100%;
  }

  .title-block {
    display: table-cell;
  }

  .centered {
    display: flex;
    width: 100%;
    justify-content: center;
  }

  .query-editor {
    border-style: solid;
    border-width: 1px;
  }

  .query-editor.preview {
    font-size: 14px;
    min-height: 48px;
  }

  .action-icon {
    color: var(--color-blue-tabs-active);
    cursor: pointer;
    padding: 0 8px;
    display: flex;
    font-size: 16px;
    align-items: center;
    justify-content: center;
  }

  .hidden {
    display: none;
  }

  .ivu-poptip-body-content p {
    display: block;
    text-align: justify;
    font-size: 13px;
  }

  .description {
    width: 100%;
    overflow-y: auto;
    word-break: normal;
    white-space: normal;
    position: relative;
  }
</style>
